import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "modal",
  id__: `#c_lassFormModal_2`,
  ref: "classFormModal1"
}
const _hoisted_2 = { class: "modal-dialog modal-xl" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header bg-secondary text-light" }
const _hoisted_5 = { class: "modal-title" }
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "container-fluid" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-12 col-xl-7" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = {
  key: 0,
  class: "col-12"
}
const _hoisted_12 = { class: "form-floating btn-group flex-fill d-flex mb-3" }
const _hoisted_13 = {
  key: 0,
  class: "position-absolute col-10 px-2 d-flex flex-row justify-content-center mt-4 overflow-hidden"
}
const _hoisted_14 = { class: "d-flex flex-row align-items-center text-truncate" }
const _hoisted_15 = { class: "ms-2" }
const _hoisted_16 = { class: "dropdown-menu dropdown-menu-end w-100" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  class: "dropdown-item",
  href: "#"
}
const _hoisted_19 = { class: "" }
const _hoisted_20 = { class: "col-12 mb-3" }
const _hoisted_21 = {
  class: "input-group flex-nowrap",
  id: "class-title-group"
}
const _hoisted_22 = { class: "form-floating flex-fill" }
const _hoisted_23 = { class: "input-group-text text-center flex-column pb-0 bg-body" }
const _hoisted_24 = { class: "form-check form-switch ps-0" }
const _hoisted_25 = { class: "col-12 col-md-6" }
const _hoisted_26 = { class: "form-floating btn-group flex-fill d-flex mb-3" }
const _hoisted_27 = {
  key: 0,
  class: "position-absolute col-10 px-2 d-flex flex-row justify-content-center mt-4 overflow-visible"
}
const _hoisted_28 = { class: "d-flex flex-row align-items-center text-truncate overflow-visible" }
const _hoisted_29 = { class: "fs-4 lh-1 fw-bold ms-2" }
const _hoisted_30 = { class: "dropdown-menu dropdown-menu-end w-100" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = {
  class: "dropdown-item",
  href: "#"
}
const _hoisted_33 = { class: "" }
const _hoisted_34 = { class: "col-12 col-md-6" }
const _hoisted_35 = {
  class: "input-group",
  id: "time-input-group"
}
const _hoisted_36 = { class: "form-floating mb-3 col-4" }
const _hoisted_37 = {
  class: "form-floating btn-group flex-fill d-flex mb-3 col-4",
  id: "class-minutes-group"
}
const _hoisted_38 = {
  key: 0,
  class: "position-absolute col-10 px-2 d-flex flex-row justify-content-center mt-4 lh-1 overflow-hidden"
}
const _hoisted_39 = { class: "d-flex flex-row align-items-center fw-bold fs-4 text-truncate" }
const _hoisted_40 = { class: "" }
const _hoisted_41 = { class: "dropdown-menu dropdown-menu-end text-center" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = {
  class: "dropdown-item",
  href: "#"
}
const _hoisted_44 = { class: "" }
const _hoisted_45 = {
  class: "form-floating btn-group flex-fill d-flex mb-3 col-4",
  id: "class-am-pm-group"
}
const _hoisted_46 = {
  key: 0,
  class: "position-absolute col-10 px-2 d-flex flex-row justify-content-center mt-4 overflow-hidden"
}
const _hoisted_47 = { class: "d-flex flex-row align-items-center text-truncate" }
const _hoisted_48 = { class: "fw-bold me-2" }
const _hoisted_49 = { class: "dropdown-menu dropdown-menu-end text-center" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = {
  class: "dropdown-item",
  href: "#"
}
const _hoisted_52 = { class: "" }
const _hoisted_53 = { class: "col-12 col-md-5" }
const _hoisted_54 = { class: "form-floating btn-group flex-fill d-flex mb-3" }
const _hoisted_55 = {
  key: 0,
  class: "position-absolute col-10 px-2 d-flex flex-row justify-content-center mt-4 overflow-hidden"
}
const _hoisted_56 = { class: "d-flex flex-row align-items-center text-truncate" }
const _hoisted_57 = { class: "ms-2 fw-bold" }
const _hoisted_58 = { class: "dropdown-menu dropdown-menu-end w-100" }
const _hoisted_59 = ["onClick"]
const _hoisted_60 = {
  class: "dropdown-item",
  href: "#"
}
const _hoisted_61 = { class: "col-12 col-md-3 mb-3" }
const _hoisted_62 = {
  class: "input-group-text text-center flex-column bg-body pb-0",
  id: "class-active-group"
}
const _hoisted_63 = { class: "form-check form-switch ps-0" }
const _hoisted_64 = { class: "col-12 col-md-4 mb-3" }
const _hoisted_65 = {
  class: "input-group-text flex-column align-items-start bg-body pt-1 pb-0",
  id: "class-active-group"
}
const _hoisted_66 = { class: "form-check form-switch small" }
const _hoisted_67 = { class: "form-check form-switch small" }
const _hoisted_68 = { class: "col-12" }
const _hoisted_69 = { class: "form-floating mb-3" }
const _hoisted_70 = { class: "col-12 col-xl-5 pb-3" }
const _hoisted_71 = { class: "border rounded d-flex flex-column h-100 p-3 pt-2" }
const _hoisted_72 = { class: "" }
const _hoisted_73 = { class: "small text-center mb-1" }
const _hoisted_74 = { class: "d-flex align-items-center" }
const _hoisted_75 = ["src"]
const _hoisted_76 = { class: "text-center" }
const _hoisted_77 = ["onClick", "disabled"]
const _hoisted_78 = { class: "modal-footer" }
const _hoisted_79 = { class: "container d-flex flex-row justify-content-between" }
const _hoisted_80 = ["disabled"]
const _hoisted_81 = ["disabled"]
const _hoisted_82 = ["disabled"]
const _hoisted_83 = ["disabled"]
const _hoisted_84 = { key: 0 }
const _hoisted_85 = {
  key: 0,
  class: "fas fa-spinner fa-spin ms-1"
}
const _hoisted_86 = {
  key: 1,
  class: "text-light"
}
const _hoisted_87 = { class: "row" }
const _hoisted_88 = { class: "col" }
const _hoisted_89 = { class: "col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_rank_icon = _resolveComponent("rank-icon")!
  const _component_class_image_modal = _resolveComponent("class-image-modal")!
  const _component_confirm_delete_class_modal = _resolveComponent("confirm-delete-class-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, [
            _cache[18] || (_cache[18] = _createElementVNode("i", { class: "fas fa-chalkboard-teacher fa-fw me-2" }, null, -1)),
            _createTextVNode(_toDisplayString(_ctx.title), 1)
          ]),
          _cache[19] || (_cache[19] = _createElementVNode("button", {
            type: "button",
            class: "btn-close btn-sm btn-close-white",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("form", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  (_ctx.mode == 'new')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-control flex-fill d-flex rounded-0 rounded-start text-center",
                            type: "text",
                            id: "class-type",
                            style: {"color":"transparent !important"},
                            placeholder: "Plantilla de Clase",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.classTemplate) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.classTemplate]
                          ]),
                          (_ctx.editedData.classType)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, [
                                  _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.classList[_ctx.scheduleType][_ctx.editedData.classType]
                                ?.title || _ctx.editedData.classType), 1)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _cache[21] || (_cache[21] = _createElementVNode("button", {
                            type: "button",
                            class: "col-2 col-lg-1 btn btn-outline-secondary dropdown-toggle dropdown-toggle-split d-flex justify-content-center align-items-center",
                            "data-bs-toggle": "dropdown",
                            "aria-expanded": "false"
                          }, [
                            _createElementVNode("span", { class: "visually-hidden" }, "Abrir Lista Plantillas")
                          ], -1)),
                          _createElementVNode("ul", _hoisted_16, [
                            _createElementVNode("li", {
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.classTemplate = ''))
                            }, [...(_cache[20] || (_cache[20] = [
                              _createElementVNode("a", {
                                class: "dropdown-item",
                                href: "#"
                              }, [
                                _createElementVNode("span", { class: "" }, "Ninguna")
                              ], -1)
                            ]))]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(
                            _ctx.classList[_ctx.scheduleType] as ClassData
                          ), ([key, val], ind) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: ind,
                                onClick: ($event: any) => (_ctx.classTemplate = key)
                              }, [
                                _createElementVNode("a", _hoisted_18, [
                                  _createElementVNode("span", _hoisted_19, _toDisplayString(val?.title), 1)
                                ])
                              ], 8, _hoisted_17))
                            }), 128))
                          ]),
                          _cache[22] || (_cache[22] = _createElementVNode("label", {
                            for: "class-type",
                            class: "opacity-100"
                          }, "Plantilla", -1))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control fs-3 fw-bold text-center rounded-end-0 rounded-0 rounded-start",
                          id: "class-title",
                          ref: "classTitle",
                          placeholder: "Nombre",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editedData.title) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.editedData.title]
                        ]),
                        _cache[23] || (_cache[23] = _createElementVNode("label", {
                          for: "class-title",
                          class: "opacity-100"
                        }, "Nombre", -1))
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _cache[24] || (_cache[24] = _createElementVNode("label", {
                          class: "form-check-label",
                          for: "show-title"
                        }, " Mostrar ", -1)),
                        _createElementVNode("div", _hoisted_24, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input secondary mt-0 ms-0",
                            type: "checkbox",
                            role: "switch",
                            id: "show-title",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editedData.showTitle) = $event))
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.editedData.showTitle]
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-control flex-fill d-flex rounded-0 rounded-start text-center",
                        type: "text",
                        id: "class-day",
                        style: {"color":"transparent !important"},
                        placeholder: "Día",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editedData.weekDay) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.editedData.weekDay]
                      ]),
                      (_ctx.editedData.weekDay)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.weekdays[_ctx.editedData.weekDay]), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _cache[25] || (_cache[25] = _createElementVNode("button", {
                        type: "button",
                        class: "col-2 btn btn-outline-secondary dropdown-toggle dropdown-toggle-split d-flex justify-content-center align-items-center",
                        "data-bs-toggle": "dropdown",
                        "aria-expanded": "false"
                      }, [
                        _createElementVNode("span", { class: "visually-hidden" }, "Abrir Lista de Días")
                      ], -1)),
                      _createElementVNode("ul", _hoisted_30, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekdays, (day, key) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: key,
                            onClick: ($event: any) => (_ctx.editedData.weekDay = key)
                          }, [
                            _createElementVNode("a", _hoisted_32, [
                              _createElementVNode("span", _hoisted_33, _toDisplayString(day), 1)
                            ])
                          ], 8, _hoisted_31))
                        }), 128))
                      ]),
                      _cache[26] || (_cache[26] = _createElementVNode("label", {
                        for: "class-day",
                        class: "opacity-100"
                      }, "Día", -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          min: "1",
                          max: "12",
                          class: "form-control fw-bold fs-4 text-center",
                          id: "class-hour",
                          ref: "classHour",
                          placeholder: "Hora",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.classTimeStructure.hour) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.classTimeStructure.hour]
                        ]),
                        _cache[27] || (_cache[27] = _createElementVNode("label", {
                          for: "class-hour",
                          class: "opacity-100"
                        }, "Hora", -1))
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-control flex-fill d-flex text-center",
                          type: "text",
                          id: "class-minutes",
                          style: {"color":"transparent !important"},
                          placeholder: "Minutos",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.classTimeStructure.minutes) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.classTimeStructure.minutes]
                        ]),
                        (_ctx.classTimeStructure.minutes)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                              _createElementVNode("div", _hoisted_39, [
                                _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.classTimeStructure.minutes), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _cache[28] || (_cache[28] = _createElementVNode("button", {
                          type: "button",
                          class: "col-4 btn btn-outline-secondary dropdown-toggle dropdown-toggle-split d-flex justify-content-center align-items-center",
                          "data-bs-toggle": "dropdown",
                          "aria-expanded": "false"
                        }, [
                          _createElementVNode("span", { class: "visually-hidden" }, "Abrir Lista de Minutos")
                        ], -1)),
                        _createElementVNode("ul", _hoisted_41, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.minutes, (minute) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: minute,
                              onClick: ($event: any) => (_ctx.classTimeStructure.minutes = minute)
                            }, [
                              _createElementVNode("a", _hoisted_43, [
                                _createElementVNode("span", _hoisted_44, _toDisplayString(minute), 1)
                              ])
                            ], 8, _hoisted_42))
                          }), 128))
                        ]),
                        _cache[29] || (_cache[29] = _createElementVNode("label", {
                          for: "class-hour",
                          class: "opacity-100"
                        }, "Minutos", -1))
                      ]),
                      _createElementVNode("div", _hoisted_45, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-control flex-fill d-flex text-center",
                          type: "text",
                          id: "class-am-pm",
                          style: {"color":"transparent !important"},
                          placeholder: "am/pm",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.classTimeStructure.am_pm) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.classTimeStructure.am_pm]
                        ]),
                        (_ctx.classTimeStructure.am_pm)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                              _createElementVNode("div", _hoisted_47, [
                                _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.classTimeStructure.am_pm), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _cache[30] || (_cache[30] = _createElementVNode("button", {
                          type: "button",
                          class: "col-4 btn btn-outline-secondary dropdown-toggle dropdown-toggle-split d-flex justify-content-center align-items-center",
                          "data-bs-toggle": "dropdown",
                          "aria-expanded": "false"
                        }, [
                          _createElementVNode("span", { class: "visually-hidden" }, "Abrir Lista AM/PM")
                        ], -1)),
                        _createElementVNode("ul", _hoisted_49, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.am_pm, (item) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: item,
                              onClick: ($event: any) => (_ctx.classTimeStructure.am_pm = item)
                            }, [
                              _createElementVNode("a", _hoisted_51, [
                                _createElementVNode("span", _hoisted_52, _toDisplayString(item), 1)
                              ])
                            ], 8, _hoisted_50))
                          }), 128))
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-control flex-fill d-flex rounded-0 rounded-start text-center",
                        type: "text",
                        id: "class-rank",
                        style: {"color":"transparent !important"},
                        placeholder: "Requiere Rango",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.editedData.requiredRank) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.editedData.requiredRank]
                      ]),
                      (_ctx.editedData.requiredRank)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                            _createElementVNode("div", _hoisted_56, [
                              _createElementVNode("span", _hoisted_57, [
                                _createElementVNode("i", {
                                  class: _normalizeClass(
                                _ctx.ranksListNames.find(
                                  (rank) => rank.id === _ctx.editedData.requiredRank
                                )?.iconClass + ' me-1'
                              )
                                }, null, 2),
                                _createTextVNode(_toDisplayString(_ctx.ranksListNames.find(
                                (rank) => rank.id === _ctx.editedData.requiredRank
                              )?.name || _ctx.editedData.requiredRank), 1)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _cache[32] || (_cache[32] = _createElementVNode("button", {
                        type: "button",
                        class: "col-2 btn btn-outline-secondary dropdown-toggle dropdown-toggle-split d-flex justify-content-center align-items-center",
                        "data-bs-toggle": "dropdown",
                        "aria-expanded": "false"
                      }, [
                        _createElementVNode("span", { class: "visually-hidden" }, "Abrir Lista de Rangos")
                      ], -1)),
                      _createElementVNode("ul", _hoisted_58, [
                        _createElementVNode("li", {
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.editedData.requiredRank = ''))
                        }, [...(_cache[31] || (_cache[31] = [
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            href: "#"
                          }, [
                            _createElementVNode("span", null, "Ninguno")
                          ], -1)
                        ]))]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ranksListNames, (rank, key) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: key,
                            onClick: ($event: any) => (_ctx.editedData.requiredRank = rank.id)
                          }, [
                            _createElementVNode("a", _hoisted_60, [
                              _createElementVNode("span", null, [
                                _createVNode(_component_rank_icon, {
                                  "icon-class": rank.iconClass,
                                  "extra-class": "me-2"
                                }, null, 8, ["icon-class"]),
                                _createTextVNode(_toDisplayString(rank.name), 1)
                              ])
                            ])
                          ], 8, _hoisted_59))
                        }), 128))
                      ]),
                      _cache[33] || (_cache[33] = _createElementVNode("label", {
                        for: "class-rank",
                        class: "opacity-100"
                      }, "Rango Mínimo", -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("div", _hoisted_62, [
                      _cache[34] || (_cache[34] = _createElementVNode("label", {
                        class: "form-check-label",
                        for: "class-active"
                      }, " Activa ", -1)),
                      _createElementVNode("div", _hoisted_63, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input mt-0 ms-0 secondary",
                          type: "checkbox",
                          role: "switch",
                          id: "class-active",
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.editedData.active) = $event))
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.editedData.active]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_64, [
                    _createElementVNode("div", _hoisted_65, [
                      _createElementVNode("div", _hoisted_66, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input pkg-gtr-go",
                          type: "checkbox",
                          id: "gtrLite",
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.allow.gtrLite) = $event))
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.allow.gtrLite]
                        ]),
                        _cache[35] || (_cache[35] = _createElementVNode("label", {
                          class: "form-check-label",
                          for: "gtrLite"
                        }, "GTR Go", -1))
                      ]),
                      _createElementVNode("div", _hoisted_67, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input pkg-gtr-fly",
                          type: "checkbox",
                          id: "gtrBasic",
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.allow.gtrBasic) = $event))
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.allow.gtrBasic]
                        ]),
                        _cache[36] || (_cache[36] = _createElementVNode("label", {
                          class: "form-check-label",
                          for: "gtrBasic"
                        }, "GTR Fly / Win", -1))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_68, [
                    _createElementVNode("div", _hoisted_69, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control fs-5 fw-bold text-center",
                        id: "class-Link",
                        ref: "classLink",
                        placeholder: "Link",
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.editedData.link) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.editedData.link]
                      ]),
                      _cache[37] || (_cache[37] = _createElementVNode("label", {
                        for: "class-link",
                        class: "opacity-100"
                      }, "Link", -1))
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_70, [
                _createElementVNode("div", _hoisted_71, [
                  _createElementVNode("div", _hoisted_72, [
                    _cache[40] || (_cache[40] = _createElementVNode("h5", null, "Imagen", -1)),
                    _createElementVNode("div", _hoisted_73, [
                      _cache[38] || (_cache[38] = _createElementVNode("span", { class: "fw-bold" }, "Dimensiones:", -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.imageDimensionsString), 1)
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["col-9 mx-auto image-container justify-content-center d-flex mb-3 shadow-lg", [_ctx.editedData.scheduleType]])
                    }, [
                      _createElementVNode("span", _hoisted_74, _toDisplayString(_ctx.imageDimensionsString), 1),
                      _createElementVNode("img", {
                        src: _ctx.getImage(),
                        alt: "[Imagen de la Clase]",
                        class: "img-fluid"
                      }, null, 8, _hoisted_75)
                    ], 2),
                    _createElementVNode("div", _hoisted_76, [
                      _createVNode(_component_class_image_modal, {
                        "class-id": "classId",
                        onUpdateImage: _ctx.updateImage,
                        "image-width": "1024",
                        "image-height": _ctx.imageHeight,
                        "aspect-ratio": _ctx.imageAspectRatio
                      }, {
                        button: _withCtx(({ onClick }) => [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-outline-secondary",
                            onClick: onClick,
                            disabled: _ctx.saving
                          }, [...(_cache[39] || (_cache[39] = [
                            _createElementVNode("i", { class: "fas fa-image fa-fw me-1" }, null, -1),
                            _createTextVNode("Cambiar Imagen ", -1)
                          ]))], 8, _hoisted_77)
                        ]),
                        _: 1
                      }, 8, ["onUpdateImage", "image-height", "aspect-ratio"])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_78, [
          _createElementVNode("div", _hoisted_79, [
            _createElementVNode("div", null, [
              (_ctx.editMode)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.confirmDeleteClass())),
                    disabled: _ctx.saving,
                    type: "button",
                    class: "btn btn-sm btn-outline-danger me-2"
                  }, [...(_cache[41] || (_cache[41] = [
                    _createElementVNode("i", { class: "far fa-trash-alt fa-fw me-1" }, null, -1),
                    _createTextVNode("Eliminar ", -1)
                  ]))], 8, _hoisted_80))
                : _createCommentVNode("", true),
              (_ctx.editMode)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.undoChanges())),
                    disabled: _ctx.saving,
                    type: "button",
                    class: "btn btn-sm btn-outline-secondary"
                  }, [...(_cache[42] || (_cache[42] = [
                    _createElementVNode("i", { class: "fas fa-undo fa-fw me-1" }, null, -1),
                    _createTextVNode("Deshacer ", -1)
                  ]))], 8, _hoisted_81))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.cancelEdit())),
                disabled: _ctx.saving,
                class: "btn btn-sm btn-outline-danger me-2"
              }, [...(_cache[43] || (_cache[43] = [
                _createElementVNode("i", { class: "fas fa-ban fa-fw me-1" }, null, -1),
                _createTextVNode("Cancelar ", -1)
              ]))], 8, _hoisted_82),
              _createElementVNode("button", {
                onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.saveClass())),
                disabled: _ctx.saving || !_ctx.isClassEdited,
                class: _normalizeClass(["btn btn-sm", _ctx.saved ? 'btn-success' : 'btn-outline-success'])
              }, [
                (!_ctx.saved)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_84, [
                      _cache[44] || (_cache[44] = _createElementVNode("i", { class: "fas fa-save fa-fw me-1" }, null, -1)),
                      _cache[45] || (_cache[45] = _createTextVNode("Guardar ", -1)),
                      (_ctx.saving)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_85))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_86, [...(_cache[46] || (_cache[46] = [
                      _createTextVNode("Guardado", -1),
                      _createElementVNode("i", { class: "fas fa-check ms-1" }, null, -1)
                    ]))]))
              ], 10, _hoisted_83)
            ])
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["container", { 'visually-hidden': _ctx.devHelpersHidden }])
        }, [
          _createElementVNode("div", _hoisted_87, [
            _createElementVNode("div", _hoisted_88, [
              _cache[47] || (_cache[47] = _createElementVNode("h5", { class: "fw-bold" }, "Objeto Editado", -1)),
              _createElementVNode("pre", null, _toDisplayString(_ctx.editedData), 1)
            ]),
            _createElementVNode("div", _hoisted_89, [
              _cache[48] || (_cache[48] = _createElementVNode("h5", { class: "fw-bold" }, "Objeto Original", -1)),
              _createElementVNode("pre", null, _toDisplayString(_ctx.originalData), 1)
            ])
          ])
        ], 2)
      ])
    ]),
    _createVNode(_component_confirm_delete_class_modal, {
      id: "confirmDeleteClassModal_onEditClass",
      "class-info": _ctx.originalData,
      onDeleteClass: _ctx.deleteClass
    }, null, 8, ["class-info", "onDeleteClass"])
  ], 512))
}